import { useState } from 'react';
import axios from 'axios';
import { Input } from './ui/input';
import { Button } from './ui/button';
import { toast } from 'sonner';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export const NewsletterBox = () => {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      await axios.post(`${API}/newsletter`, { name, email });
      toast.success('Inscrito com sucesso!');
      setName('');
      setEmail('');
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Erro ao inscrever');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="bg-primary/10 border-2 border-primary rounded-sm p-8" data-testid="newsletter-box">
      <h3 className="text-2xl font-bold mb-2">Junte-se a 10.000+ Indivíduos Soberanos</h3>
      <p className="text-muted-foreground mb-6">
        Receba as últimas notícias e tutoriais sobre Bitcoin diretamente no seu email.
      </p>
      <form onSubmit={handleSubmit} className="space-y-4">
        <Input
          type="text"
          placeholder="Seu nome"
          value={name}
          onChange={(e) => setName(e.target.value)}
          required
          data-testid="newsletter-name-input"
        />
        <Input
          type="email"
          placeholder="Seu email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
          data-testid="newsletter-email-input"
        />
        <Button type="submit" disabled={loading} className="w-full" data-testid="newsletter-submit-button">
          {loading ? 'Inscrevendo...' : 'Inscrever-se'}
        </Button>
      </form>
    </div>
  );
};
